import axios from "axios";

const defaultState = {
  reports: [],
};

export default {
  namespaced: true,

  state: {
    reports: [],

    reportsLoading: false,

    downloadReportLoading: false,
  },

  mutations: {
    setReports(state, data) {
      state.reports = data;
    },

    setReportsLoading(state, data) {
      state.reportsLoading = data;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    },

    setDownloadReportLoading(state, data) {
      state.downloadReportLoading = data;
    },
  },

  actions: {
    fetchReports({ commit, dispatch }) {
      return axios.get(process.env.VUE_APP_API_URL + "reports")
        .then(({ data }) => {
          commit("setReports", data || []);
          return data;
        })
        .catch(({ response }) => dispatch("handleResponse", response, { root: true }));
    },

    saveReport({ commit, state }, { name, organization }) {
      return axios.post(process.env.VUE_APP_API_URL + "reports", { name, organization })
        .then(({ data }) => {
          const reports = [ ...state.reports, data ];
          commit("setReports", reports);
        });
    },

    deleteReport({ commit, state }, reportID) {
      return axios.delete(process.env.VUE_APP_API_URL + `reports/${reportID}`)
        .then(() => {
          let reports = [ ...state.reports ];
          reports = reports.filter(report => report.uuid != reportID);
          commit("setReports", reports);
        });
    },

    updateReport({ commit, state }, { uuid, name, organization }) {
      return axios.put(process.env.VUE_APP_API_URL + `reports/${uuid}`, { name, organization })
        .then(({ data }) => {
          const reports = [ ...state.reports ];

          const index = reports.findIndex(report => report.uuid == uuid);

          reports.splice(index, 1, data);

          commit("setReports", reports);
        });
    },

    generateReport(_, { uuid, title, daterange }) {
      return axios.post(process.env.VUE_APP_API_URL + `reports/${uuid}/generate`, { title, daterange })
        .then(({ data }) => data.uri);
    },
  }
}